import { render, staticRenderFns } from "./SubscribePromoButton.vue?vue&type=template&id=5505f621&"
import script from "./SubscribePromoButton.vue?vue&type=script&lang=js&"
export * from "./SubscribePromoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports